import { render, staticRenderFns } from "./myPagination.vue?vue&type=template&id=6d1f6226&"
import script from "./myPagination.vue?vue&type=script&lang=js&"
export * from "./myPagination.vue?vue&type=script&lang=js&"
import style0 from "./myPagination.vue?vue&type=style&index=0&id=6d1f6226&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports